import { Box, FormControl, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { fileToBase64 } from '~/utils/fileToBase64';
import * as styles from './styles';
import { InputProps } from './types';

export default function CustomizedInputs({
  name: _name,
  label,
  onChangeFile,
  error,
  alternateIcon,
  baseIcon,
  ..._props
}: InputProps) {
  const [existFile, setExistFile] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  // Limpar os recursos do preview quando o componente for desmontado
  useEffect(() => {
    return () => {
      // Revogar URL do objeto criado para evitar vazamento de memória
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: async (files) => {
      setExistFile(true);
      if (onChangeFile && files[0]) {
        // Criar uma URL de visualização para o arquivo se for uma imagem
        if (files[0].type.startsWith('image/')) {
          const imageUrl = URL.createObjectURL(files[0]);
          setPreviewUrl(imageUrl);
        } else {
          // Se não for uma imagem, limpar o preview
          setPreviewUrl(null);
        }

        // Converter para base64 e chamar o callback
        await fileToBase64(files[0]).then((res) => {
          const file = res?.split(',')[1];
          onChangeFile({
            Name: files[0].name,
            File: file as string
          });
        });
      }
    },
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf']
    }
  });

  return (
    <Box>
      <Typography sx={styles.labelStyle} textAlign="center">
        {label}
      </Typography>
      <FormControl variant="standard" sx={styles.container}>
        <Box sx={styles.input(existFile, error)} {...getRootProps()}>
          <input {...getInputProps()} />

          {previewUrl ? (
            // Mostrar preview da imagem se disponível
            <Box sx={styles.previewContainer}>
              <img
                src={previewUrl}
                alt="Preview"
                style={{
                  maxWidth: '100%',
                  maxHeight: '150px',
                  objectFit: 'contain'
                }}
              />
            </Box>
          ) : (
            // Se não houver preview, mostrar o ícone padrão
            <Box sx={styles.icon}>
              {!existFile && baseIcon}
              {existFile && alternateIcon}
            </Box>
          )}

          <Typography variant="body1" sx={styles.inputText}>
            {!existFile && 'Clique para fazer o carregamento do arquivo'}
            {existFile && 'Clique para substituir esse arquivo'}
          </Typography>
        </Box>
      </FormControl>
    </Box>
  );
}
